import { GameConfig } from '../game-config.model';
import { Mode } from '../game-mode.model';

export class Settings {
  gameConfig: GameConfig;
  randomName: string;
  gameModes: Mode[];
}
